import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  investor_group_type: {
    name: 'Investor Group Type'
  },
  percent_of_nav: {
    name: 'Investor group NAV percentage'
  }
};

export function InvestmentGroup({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_GROUP,
    onChangeFund,
    schema: schema.INVESTOR_GROUP,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.INVESTOR_GROUP?.field_names || [],
    columnLables,
    funds,
    isMultiFunds,
    tableName: 'INVESTOR_GROUP',
    onAddColumn,
    onDeleteColumn,
    //@ts-ignore
    order: 208,
    hasTableOrderNumber: false
  });

  return (
    <Table
      id="reporttables-investment-group-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
